export default __webpack_public_path__ + "static/thumb-12-75a5e81aba29a92e53958f659c345e62.jpg";